<template>
  <div class="question-wrap">
    <div class="start-test" v-if="currentIndex === -1">
      <div class="question-content">
        <div class="question">
          <div class="left-red"></div>
          <p>{{$t('upgrade_page_views_settled_in_index_1151')}}</p>
        </div>
        <div class="test-wrap">{{$t('upgrade_page_views_settled_in_question_index_1160')}}</div>
      </div>
      <div class="start-q" @click="nextQ">{{$t('upgrade_page_views_settled_in_question_index_1161')}}</div>
    </div>
    <div class="end-test" v-else-if="currentIndex === 6">
      <i class="el-icon-success success-icon"></i>
      <p>{{$t('upgrade_page_views_settled_in_question_index_1162')}}</p>
      <p class="end-text">{{$t('upgrade_page_views_settled_in_question_index_1163')}}</p>
      <div class="last-btn" @click="lastHandle">{{ $t('upgrade_page_views_user_set_account_788') }}</div>
    </div>
    <div v-else>
      <div class="rate-wrap">
        <div class="rate-left">
          <p class="rate-text">{{$t('upgrade_page_views_settled_in_question_index_1164')}}</p>
        </div>

        <div class="rate-right">
          <div class="rate-line">
            <div
              class="current-rate"
              :style="{
                width:
                  (currentIndex === 6 ? currentIndex : currentIndex + 1) * 51 +
                  'px'
              }"
            ></div>
          </div>
          <div class="rate-num">{{$t('upgrade_page_views_settled_in_question_index_1165', [
              currentIndex === 6 ? currentIndex : currentIndex + 1
            ])}}</div>
        </div>
      </div>
      <div class="question-content">
        <div class="question">
          <div class="left-red"></div>
          <p>{{ currentQuestion.question }}</p>
        </div>
        <div class="answer-wrap">
          <div
            class="answer-option"
            :class="item.isSelected ? 'is-selected' : ''"
            v-for="(item, index) in currentQuestion.options"
            :key="index"
            @click="select(index)"
          >
            <p>{{ item.id }}.</p>
            <p>{{ item.text }}</p>
          </div>
        </div>
        <div class="check-tips" @click="showTips = !showTips">
          <span class="error">{{ showError ? $t('upgrade_page_views_settled_in_question_index_1166') : '' }}</span>
          <div class="right">
            <p>{{$t('upgrade_page_views_settled_in_question_index_1167')}}</p>
            <i class="el-icon-question"></i>
          </div>
        </div>
        <div class="tips-wrap" v-if="showTips">
          <div class="tip-wrap">
            <div
              class="options-wrap"
              v-for="(option, index) in currentTip.content"
              :key="index"
            >
              <div
                class="option"
                v-for="(item, index) in option.options"
                :key="index"
              >
                <div class="option-circle"></div>
                <p>{{ item }}</p>
              </div>
            </div>
            <div class="tips-exp">{{ currentTip.example }}</div>
          </div>
        </div>
        <div class="tips">
          <div class="tip-title"></div>
          <div class="tip-option"></div>
        </div>
        <div class="nav-wrap">
          <div class="last-q" v-if="currentIndex !== 0" @click="lastQ">{{$t('upgrade_page_views_settled_in_question_index_1168')}}</div>
          <div class="next-q" @click="nextQ">
            {{ currentIndex === 5 ? $t('upgrade_page_views_settled_in_question_index_1169') : $t('upgrade_page_views_settled_in_question_index_1170') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import QuestionList from './question';
import tipsList from './tips';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      questionList: QuestionList,
      currentIndex: -1,
      allRate: 0,
      tipsList: tipsList,
      showTips: false,
      showError: false
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    currentQuestion() {
      if (this.currentIndex > -1) {
        return this.questionList[this.currentIndex];
      } else {
        return { question: '' };
      }
    },
    currentTip() {
      return this.tipsList[this.currentIndex];
    }
  },
  methods: {
    lastHandle() {
      if (this.allRate > 89) {
        this.$emit('toStep', 2);
      } else {
        this.currentIndex = -1;
        this.questionList.forEach(e => {
          e.userAnswer = [];
          e.options.forEach(option => {
            option.isSelected = false;
          });
        });
        this.selectAnswerArr = [];
        this.allRate = 0;
        this.showTips = false;
      }
    },
    lastQ() {
      this.currentIndex = this.currentIndex - 1;
    },
    nextQ() {
      const { userAnswer, answer } = this.currentQuestion;
      if (this.currentIndex === -1) {
        this.currentIndex += 1;
        return;
      }
      if (this.currentQuestion.userAnswer.length === 0) {
        this.$message(i18n.t('upgrade_page_views_settled_in_question_index_1171'));
        return;
      }
      if (
        userAnswer.length === answer.length &&
        userAnswer.length === [...new Set([...userAnswer, ...answer])].length
      ) {
        this.showTips = false;
        this.showError = false;
        if (this.currentIndex === 5) {
          this.submit();
        }
        this.currentIndex += 1;
      } else {
        this.showTips = true;
        this.showError = true;
      }
    },
    select(index) {
      this.showError = false;
      if (this.currentQuestion.type === 'single') {
        this.currentQuestion.options.forEach(e => {
          e.isSelected = false;
        });
      }
      this.$set(
        this.currentQuestion.options[index],
        'isSelected',
        !this.currentQuestion.options[index].isSelected
      );
      this.currentQuestion.userAnswer = [];
      this.currentQuestion.options.forEach(e => {
        if (e.isSelected) {
          this.currentQuestion.userAnswer.push(e.id);
        }
      });
    },
    submit() {
      this.allRate = 100;
      window.localStorage.setItem(this.userInfo.uuid + '_RATE', this.allRate);
    }
  }
};
</script>

<style lang="scss" scoped>
.question-wrap {
  position: relative;
  margin-bottom: 200px;
  margin-top: 60px;
  .rate-wrap {
    width: 980px;
    height: 80px;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    border-radius: 8px;
    margin-bottom: 20px;
    .rate-left {
      display: flex;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 80px;
      color: #636d86;
      .rate-text {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 80px;
        color: #8c94aa;
        margin-left: 31px;
      }
    }
    .rate-right {
      display: flex;
      align-items: center;
      .rate-line {
        width: 301px;
        height: 6px;
        border-radius: 3px;
        background: #e6e6e6;
        margin-right: 25px;
        .current-rate {
          transition: all 0.3s ease;
          border-radius: 3px;
          height: 6px;
          background: #64cd88;
        }
      }
    }
  }
  .question-content {
    background: white;
    padding: 44px 0;
    border-radius: 8px;
    .test-wrap {
      height: 180px;
      width: 100%;
      line-height: 180px;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      color: #666666;
      text-align: center;
    }
    .question {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 30px;
      color: #222c43;
      padding: 0 60px 16px 60px;
      border-bottom: 2px solid #f4f4f4;
      display: flex;
      align-items: center;
      .left-red {
        width: 4px;
        height: 18px;
        margin-right: 8px;
        background: $color-yellow;
      }
    }
    .answer-wrap {
      padding: 20px 60px;
      .answer-option {
        width: 460px;
        height: 50px;
        border: 1px solid #8c94aa;
        border-radius: 25px;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 50px;
        letter-spacing: -0.000284274px;
        color: #636d86;
        padding-left: 21px;
        margin-bottom: 10px;
        display: flex;
        cursor: pointer;
        align-items: center;
        &:hover {
          background: #f0f0f0;
        }
        p:first-child {
          margin-right: 12px;
        }
        p:last-child {
          line-height: 24px;
        }
      }

      .is-selected {
        background: rgba(222, 245, 255, 0.5);
        border: 1px solid #0fadff;
        &:hover {
          background: rgba(222, 245, 255, 0.5);
          border: 1px solid #0fadff;
        }
      }
    }
    .check-tips {
      width: 460px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #8c94aa;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 17px;
      cursor: pointer;
      margin-bottom: 40px;
      margin-left: 60px;
      .error {
        color: red;
      }
      i {
        font-size: 15px;
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .tips-wrap {
      padding-left: 60px;
      .tip-wrap {
        .tips-title {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.000284274px;
          margin-bottom: 10px;
          color: #636d86;
          span {
            width: 32px;
            height: 16px;
            line-height: 16px;
            border-radius: 4px;
            background: #ff891e;
            font-weight: 600;
            font-size: 12px;
            color: #ffffff;
            padding: 0 3px;
            text-align: center;
            margin-right: 6px;
            font-style: italic;
          }
        }
        .options-wrap,
        .tips-exp {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 28px;
          letter-spacing: -0.000284274px;
          color: #8c94aa;
          margin-bottom: 20px;
          .option {
            display: flex;
            align-items: center;

            .option-circle {
              width: 6px;
              height: 6px;
              border-radius: 100%;
              background: #8c94aa;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .next-q {
    width: 170px;
    height: 54px;
    line-height: 54px;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    background: $color-yellow;
    border-radius: 4px;
    letter-spacing: -0.000319808px;
    color: #222c43;
    margin-right: 15px;
    cursor: pointer;
  }
  .nav-wrap {
    display: flex;
    padding-left: 60px;
  }
  .last-q {
    width: 170px;
    height: 54px;
    line-height: 54px;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    background: #f1f4f6;
    margin-right: 15px;
    border-radius: 4px;
    letter-spacing: -0.000319808px;
    color: #636d86;
    cursor: pointer;
  }
  .start-q {
    background: $color-yellow;
    color: #222c43;
    border-radius: 30px;
    width: 200px;
    height: 54px;
    line-height: 54px;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    position: absolute;
    right: 0;
    bottom: -85px;
    cursor: pointer;
  }
  .end-test {
    width: 100%;
    height: 345px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: white;
    position: relative;
    i {
      font-size: 56px;
    }
    .success-icon {
      color: #52c41a;
    }
    .fail-icon {
      color: #eb5757;
    }
    .last-btn {
      border-radius: 4px;
      width: 200px;
      height: 54px;
      line-height: 54px;
      cursor: pointer;
      text-align: center;
      position: absolute;
      right: 0px;
      bottom: -80px;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      @include button-yellow;
    }
    img {
      width: 70px;
      margin-bottom: 20px;
      height: 70px;
    }
    p {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 43px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #222c43;
      margin-bottom: 2px;
    }
    .end-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #636d86;
      .check-wrong {
        cursor: pointer;
        color: #0fadff;
      }
    }
  }
}
</style>
